import { RootState } from "store/store"

export function getAuthToken(rootState: RootState) {
    const { AuthReducer } = rootState
    if (AuthReducer && AuthReducer.user && AuthReducer.user?.token && AuthReducer.user?.token?.access_Token) {
        return AuthReducer.user.token.access_Token
    }
    return null
}